import { Pipe, PipeTransform } from '@angular/core';
import { FormNamingUtil } from '../utils/form-naming.util';

@Pipe({
  name: 'checkboxName',
  pure: true
})
export class CheckboxNamePipe implements PipeTransform {
  transform(questionNumber: number, choiceNumber: number): string {
    return FormNamingUtil.getCheckboxName(questionNumber, choiceNumber);
  }
}
